import React, { useState, useEffect, useRef } from 'react';
import './InputFieldWithSuggestions.css';
import { get } from '../../../utility/utility';

function InputFieldWithSuggestions({
  id,
  value = '', // 👈 receive value directly
  onChange,
  placeholder,
  options,
  label,
  isRequired = false,
}) {
  const [inputValue, setInputValue] = useState(value);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value); // 👈 keep in sync with external value
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange({ target: { id, value: newValue } });
    const matches = options.filter((opt) => opt.label.toLowerCase().includes(newValue.toLowerCase()));
    setFilteredOptions(matches);
    setMenuIsOpen(matches.length > 0);
  };

  const handleSelect = (option) => {
    const label = get(option, 'label')
    setInputValue(label);
    onChange({ target: { id, value: label } });
    setMenuIsOpen(false);
  };

  return (
    <div className="input-suggestions-container" ref={inputRef}>
      <label htmlFor={id} className="input-suggestions-label">
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <input
        id={id}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => {
          const matches = options.filter((opt) => opt.label.toLowerCase().includes(inputValue.toLowerCase()));
          setFilteredOptions(matches);
          setMenuIsOpen(matches.length > 0);
        }}
        className="input-suggestions-input"
        placeholder={placeholder ?? 'Type to search or select...'}
        autoComplete="off"
      />
      {menuIsOpen && (
        <ul className="input-suggestions-menu">
          {filteredOptions.map((option) => (
            <li
              key={option.value}
              onClick={() => handleSelect(option)}
              className="input-suggestions-option"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default InputFieldWithSuggestions;
